

import $ from 'jquery';
import tmpl from './template';
import Swiper, { Navigation, Autoplay, EffectFade, Lazy } from 'swiper';
// import './maps';

// import './marketo/mkto-enrichUTM';
import './modal/modal-gutenberg';
import './gallery/gallery';
// import './updates';
import './videoplayer';
import './youtube';
import './downloads';
// import './utm/utm';
import Geolocation from './geolocation';
import Template from './template/template';
import MktoFormLoader from './marketo/mktoFormLoader';
import MktoCountryStateManager from './marketo/mktoCountryStateManager ';
import Modal from './modal/modal';
import RoadmapModal from './modal/modal-roadmap';
import Slider from './slider/slider';
import ArchiveFilter from './archiveFilter';

window.tmpl = tmpl;

window.Swiper = Swiper;
window.Sw = window.Sw || {};
window.Sw.Navigation = Navigation;
window.Sw.Autoplay = Autoplay;
window.Sw.FadeEffect = EffectFade;
window.Sw.LazyLoading = Lazy;

window.GS = window.GS || {};
window.GS.geolocation = new Geolocation();
window.GS.MktoFormLoader = MktoFormLoader;
window.GS.Modal = new Modal();
window.GS.RoadmapModal = new RoadmapModal();
window.GS.Slider = Slider;
window.GS.Template = Template;

/**
 * Test
 */
!function(){
    document.addEventListener('gsid.login', function(event) {
        console.log('GSID Event', event);
    }, false);
}()
/**/


/**
 * Toggle sidenav
 */
!function(){
    let button = document.querySelector('[data-toggle-menu]'),
        topItems = [...document.querySelectorAll('#sidenav .menu-main > li > ul')];

    function closeItems() {
        topItems.forEach(item => {
            item.classList.remove('show');
        })
    }

    function toggleSidebar(event) {
        closeItems();

        console.log('@event: click on [data-toggle-menu]');

        this.classList.toggle('active');
        document.body.classList.toggle('active-sidenav');

        if (this.classList.contains('active')) {
            let activeItem = document.querySelector('#sidenav .menu-main > li.active > ul');
            if (activeItem) {
                // activeItem.click();
                activeItem.classList.add('show');
            }
        }
    }

    button && button.addEventListener('click', toggleSidebar);
}();
/**/


/**
 * Header scroll behaviour
 */
!function(){
    const header = document.querySelector('.layout-header');
    // const layoutBody = document.querySelector('.layout-body');

    function resizeNavbar(event) {
        if (document.body.scrollTop > 0 || document.documentElement.scrollTop > 0) {
            console.log('@scroll > 0');
            header.classList.add('header-thin');
            header.classList.add('fixed-top');
            // layoutBody.classList.add('layout-padding');
        } else {
            header.classList.remove('header-thin');
            header.classList.remove('fixed-top');
            // layoutBody.classList.remove('layout-padding');
        }
    }

    window.addEventListener('scroll', resizeNavbar);
}();
/**/


/**
 * Share buttons popover
 */
!function(selector){
    [...document.querySelectorAll(selector)].forEach((node)=>{
        $(node).popover({
            'html'      : true,
            'content'   : function() {
                // `this` is the `[data-share-button]` node
                return this.parentNode.querySelector('[data-share-controls]').outerHTML;
            },
        })
    });
}('[data-share-button]');
/**/


/**
 * Blur background for modal
 */
!function(selector){
    [...document.querySelectorAll(selector)].forEach((node) => {
        $(node).on('show.bs.modal', function(event) {
            console.log('@show.bs.modal');
            $(`body > *:not(${selector})`).addClass('blur');
        });

        $(node).on('hide.bs.modal', function(event) {
            console.log('@hide.bs.modal');
            $(`body > *:not(${selector})`).removeClass('blur');
        });
    });
}('[data-modal]');
/**/


/**
 * Archive filters
 */
!function(){
    [...document.querySelectorAll('[data-archive-filter]')].forEach((node)=>{
        new ArchiveFilter(node);
    });
}();
/**/




/**
 * Carousels
 */
$(document).ready(function() {
    $('#carouselExample').on('slide.bs.carousel', function(e) {
        var $e = $(e.relatedTarget);
        var idx = $e.index();
        var itemsPerSlide = 7;
        var totalItems = $('#carouselExample .carousel-item').length;

        if (idx >= totalItems-(itemsPerSlide-1)) {
            var it = itemsPerSlide - (totalItems - idx);

            for (var i=0; i<it; i++) {
            // append slides to end
                if (e.direction=="left") {

                    $('#carouselExample .carousel-item').eq(i).appendTo('#carouselExample .carousel-inner');

                } else {

                    $('#carouselExample .carousel-item').eq(0).appendTo('#carouselExample .carousel-inner');
                }
            }
        }
    });

});



$(document).ready(function() {
    $('#carousel-for-global-events').on('slide.bs.carousel', function(e) {
        var $e = $(e.relatedTarget);
        var idx = $e.index();
        var itemsPerSlide = 4;
        var totalItems = $('#carousel-for-global-events .carousel-item').length;

        if (idx >= totalItems-(itemsPerSlide-1)) {
            var it = itemsPerSlide - (totalItems - idx);

            for (var i=0; i<it; i++) {
            // append slides to end
                if (e.direction=="left") {

                    $('#carousel-for-global-events .carousel-item').eq(i).appendTo('#carousel-for-global-events .carousel-inner');

                } else {

                    $('#carousel-for-global-events .carousel-item').eq(0).appendTo('#carousel-for-global-events .carousel-inner');
                }
            }
        }
    });
});



$(document).ready(function() {
    $('#team-carousel-2').on('slide.bs.carousel', function(e) {
        var $e = $(e.relatedTarget);
        var idx = $e.index();
        var itemsPerSlide = 4;
        var totalItems = $('#team-carousel-2 .carousel-item').length;

        if (idx >= totalItems-(itemsPerSlide-1)) {
            var it = itemsPerSlide - (totalItems - idx);

            for (var i=0; i<it; i++) {
            // append slides to end
                if (e.direction=="left") {

                    $('#team-carousel-2 .carousel-item').eq(i).appendTo('#team-carousel-2 .carousel-inner');

                } else {

                    $('#team-carousel-2 .carousel-item').eq(0).appendTo('#team-carousel-2 .carousel-inner');
                }
            }
        }
    });
});
/**/


/**
 * Animations
 *
 *
 */

!function(){
    if (!!window.IntersectionObserver) {
        let animationObserver = new IntersectionObserver((entries, observer) => {
            entries.forEach(entry => {
            if(entry.isIntersecting){
                console.log(entry);
                entry.target.classList.add('active');
                observer.unobserve(entry.target);
            }
            });
        }, {rootMargin: "0px 0px 0px 0px"});
        document.querySelectorAll('.animationInView').forEach(node => { animationObserver.observe(node) });
    }
}();


!(function() {
  if (!!window.IntersectionObserver) {
    let highlightObserver = new IntersectionObserver(
      (entries, observer) => {
        entries.forEach(entry => {
          //  debugger
          if (entry.isIntersecting) {
            let positionData = entry.intersectionRect;
            let start = (positionData.x / window.innerWidth).toFixed(2) * 100;
            let end =
              (
                (positionData.x + positionData.width) /
                window.innerWidth
              ).toFixed(2) * 100;
            entry.target.style.backgroundImage = `url(/content/themes/building-together/dist/images/bg-structure-highlight.svg), linear-gradient(to right, #313D6B ${start}%, #FF6104 ${end}%)`;
            entry.target.style.backgroundAttachment = "fixed";
            entry.target.classList.add(entry.target.dataset.animation);
          } else {
            entry.target.classList.remove(entry.target.dataset.animation);
          }
        });
      },
      { rootMargin: "0px 0px 0px 0px", threshold: [1] }
    );

    document.querySelectorAll(".highlight>span>[data-animation='fadeIn']").forEach(node => {
      highlightObserver.observe(node);
    });

    $(".carousel").on("slid.bs.carousel", function(e) {
      document.querySelectorAll(".highlight>span>[data-animation='fadeIn']").forEach(node => {
        var data = node.getBoundingClientRect();
        var start = (data.x / window.innerWidth).toFixed(2) * 100;
        var end = ((data.x + data.width) / window.innerWidth).toFixed(2) * 100;
        node.style.backgroundImage = `url(/content/themes/building-together/dist/images/bg-structure-highlight.svg), linear-gradient(to right, #313D6B ${start}%, #FF6104 ${end}%)`;
        node.style.backgroundAttachment = "fixed";
      });

    });
  }
})();




/* CAROUSEL BLOCK
Add .active class to the first carousel-item
*/
/* !(function() {
   document.querySelectorAll("[data-carousel]>.carousel-inner>.carousel-item:first-child").forEach(node => {
        node.classList.add('active')
      });

})();
 */

/* GALLERY BLOCK
Add .active class to the first carousel-item
*/
$(document).ready(function(){
/* !(function() {	 */
	document.querySelectorAll("[data-modal-link]").forEach(function(node){
        var link = node.dataset.modalLink
        let id = node.dataset.target;
		var items = document.querySelectorAll('[data-carousel-image]')
        var triggerNode = node.closest('figure');
        var blur = node.closest('ul');
		triggerNode.addEventListener('click', function(e){

           // blur.classList.add('blur');
			
            $(id).modal();
            $(id).on('hidden.bs.modal', function (e) {
               // blur.classList.remove('blur');
              })
			items.forEach(item => {
				if(item.dataset.carouselImage === this.firstChild.dataset.modalLink){
					console.log('TRUE', item.dataset.carouselImage, e.target.dataset.link )
					item.classList.add('active')
				} else {
					console.log('FALSE', item.dataset.carouselImage, e.target.dataset.link )
					item.classList.remove('active')
					
				}
			})
		})
       });
/* })(); */
}); 

/**
 * Javascript for Job Board
 */

/**
 * Copy to clipboard function definition
*/
window.GS.copyToClipboard = function copyToClipboard(text) {
    if (window.clipboardData && window.clipboardData.setData) {
        // IE specific code path to prevent textarea being shown while dialog is visible.
        return clipboardData.setData("Text", text);

    } else if (document.queryCommandSupported && document.queryCommandSupported("copy")) {
        var textarea = document.createElement("textarea");
        textarea.textContent = text;
        textarea.style.position = "fixed";  // Prevent scrolling to bottom of page in MS Edge.
        document.body.appendChild(textarea);
        textarea.select();
        try {
            return document.execCommand("copy");  // Security exception may be thrown by some browsers.
        } catch (ex) {
            console.warn("Copy to clipboard failed.", ex);
            return false;
        } finally {
            document.body.removeChild(textarea);
        }
    }
}

const jobBoardItems = document.querySelectorAll('.js-job-link');
if (jobBoardItems) {
    jobBoardItems.forEach(function(jobBoardItem) {
        jobBoardItem.addEventListener('click', function(event) {
            // event.preventDefault();
            // let link = `${window.location.href}/#${jobBoardItem.previousElementSibling.id}`;
            let link = `${window.location.protocol}//${window.location.host}${window.location.pathname}#${jobBoardItem.dataset.jobId}`;
            window.GS.copyToClipboard(link);
            console.info(`Copied to clipboard: ${link}`);
        })
    });
}

/**
 * ... See more ... See less
 */
const detailsButton = document.querySelectorAll('.js-details-button');
if (detailsButton) {
    detailsButton.forEach(function(detailButton) {
        detailButton.addEventListener('click', function(event) {
            detailButton.parentElement.classList.toggle('d-none');
            let sibling = detailButton.parentElement.nextElementSibling;
            if (sibling) {
                detailButton.parentElement.nextElementSibling.classList.toggle('d-none');
            } else {
                detailButton.parentElement.previousElementSibling.classList.toggle('d-none');
            }
        })
    });
}

/**
 * With /#job-id link the job is the 1st on the top
 */
const hash = window.location.hash.substr(1);
if (hash) {
    const id = hash.replace(/[^0-9]/g,'');
    const parent = document.querySelector('.js-list');
    if (parent) {
        parent.insertAdjacentElement('afterbegin', document.querySelector(`#job-${id}`));
        parent.insertAdjacentElement('afterbegin', document.querySelector(`#post-${id}`));
    }
}


document.addEventListener("DOMContentLoaded", async () => {
    async function loadScript(url) {
        return new Promise((resolve, reject) => {
            const script = document.createElement("script");
            script.src = url;
            script.onload = resolve;
            script.onerror = reject;
            document.head.appendChild(script);
        });
    }

    function delay(ms) {
        return new Promise(resolve => setTimeout(resolve, ms));
    }

    async function initializeMktoForms() {
        if (typeof MktoForms2 === "undefined") {
            try {
                await loadScript("https://web.graphisoft.com/js/forms2/js/forms2.min.js?ver=2024");
            } catch (error) {
                console.error("Failed to load MktoForms2 script", error);
                return;
            }
        }

        let retryCount = 3;

        MktoForms2.whenReady(async function (form) {
            const formId = form.getId();
            let formEl = document.getElementById(`mktoForm_${formId}`);

            while (!formEl && retryCount > 0) {
                console.warn(`Form element not found, retrying in 3 seconds... (${retryCount} attempts left)`);
                await delay(3000);
                formEl = document.getElementById(`mktoForm_${formId}`);
                retryCount--;
            }

            if (!formEl) {
                console.error(`Form element with id mktoForm_${formId} not found after multiple attempts.`);
                return;
            }

            // Add hidden input for Sync_with_Marketo__c
            const hiddenInput = document.createElement('input');
            hiddenInput.type = 'hidden';
            hiddenInput.name = 'Sync_with_Marketo__c';
            hiddenInput.id = 'Sync_with_Marketo__c';
            hiddenInput.value = 'YES';
            formEl.appendChild(hiddenInput);

            new MktoCountryStateManager("https://marketing-services.graphisoft.com/marketo-api/", formEl);
        });
    }

    initializeMktoForms();
});

const header = document.getElementById('layout-header')

// todo: admin bar messes up the calculation
const getContentTop = function() {
    document.documentElement.style.setProperty('--gs-content-top', Math.round(
            document.documentElement.offsetTop - 1
            // - Math.min(window.scrollY, document.getElementById('content').offsetTop)
            // - Math.min(window.scrollY, document.documentElement.offsetTop + header.offsetTop + header.offsetHeight)
            // + document.getElementById('content').offsetTop
            + (window.scrollY < header.offsetTop ? header.offsetTop - window.scrollY : window.scrollY - header.offsetTop)
            + header.offsetHeight
        ) + 'px'
    );
}

const resizeObserver = new ResizeObserver( getContentTop
    // (entries) => {
    // for (const entry of entries) {
        // const position = window.getComputedStyle(header).getPropertyValue('position');
        // if (entry.contentBoxSize) {
        //     const contentBoxSize = entry.contentBoxSize[0];
        // }
    // }
// }
);
resizeObserver.observe(header);
window.addEventListener('scroll', getContentTop);